import React from "react";
import { Link } from "react-router-dom";
import { Plus, ArrowRight } from "lucide-react";

/**
 * Banner that appears below a search/listing results column when the
 * page surfaced fewer than 5 places. Surfaces the "Suggest a Place"
 * funnel exactly where it's most useful — when a user is staring at
 * a sparse city + category page and might know better.
 *
 * Spec-exact styling:
 *   - background #E8F2EC
 *   - border 1px #D4C9B0
 *   - rounded 10px
 *   - padding 16px
 *
 * Shown on three surfaces: Search.jsx, CityPage.jsx, and on the new
 * /suggest/ entry-point spots. Render with `compact` for the search
 * sidebar (smaller, single line) vs. full card on city hubs.
 */
const SuggestPlaceBanner = ({ context = "search" }) => (
  <Link
    to="/suggest"
    data-testid="suggest-place-banner"
    data-context={context}
    className="block mt-4 group active:scale-[0.99] transition-transform"
    style={{
      backgroundColor: "#E8F2EC",
      border: "1px solid #D4C9B0",
      borderRadius: "10px",
      padding: "16px",
    }}
  >
    <div className="flex items-start sm:items-center gap-3 flex-wrap sm:flex-nowrap">
      <div
        className="shrink-0 rounded-full flex items-center justify-center"
        style={{ width: 36, height: 36, backgroundColor: "#4A7C59" }}
      >
        <Plus className="w-5 h-5 text-white" strokeWidth={2.6} />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className="font-body font-semibold"
          style={{ color: "#1A1A0F", fontSize: "14px", lineHeight: 1.4 }}
        >
          Know a dog-friendly spot we're missing?
        </div>
        <div
          className="font-body mt-0.5"
          style={{ color: "#7A7A60", fontSize: "13px", lineHeight: 1.4 }}
        >
          Add it to Pawground and help fellow dog parents discover it.
        </div>
      </div>
      <div
        className="shrink-0 inline-flex items-center gap-1 font-body font-semibold group-hover:gap-1.5 transition-all"
        style={{ color: "#4A7C59", fontSize: "13px" }}
      >
        Add it
        <ArrowRight className="w-4 h-4" />
      </div>
    </div>
  </Link>
);

export default SuggestPlaceBanner;
